<template>
  <v-container fluid class="pa-6"
               style="max-width: 83%;"
  >
    <div v-if="!hasPagination" class="d-flex justify-center align-center" style="height: 80vh;">
    </div>
    <div v-else>
      <div>
        <h1>{{ pageTitle }}</h1>
        <p></p>
      </div>
      <div v-if="isMobile" class="mobile">
        <v-row class="pt-0 pb-0">
          <v-col :cols="isMobile ? '9' : '11'" class="pt-0 pb-0">
            <v-text-field
                type="text"
                solo
                style="border-radius: 15px;"
                prepend-inner-icon="mdi-magnify"
                placeholder="Buscar trámite por nombre..."
                v-model="search"
                @keyup.enter="getProceduresList"
            />
          </v-col>
          <v-col :cols="isMobile ? '3' : '1'" class="pt-0 pb-0" >
            <v-btn class="main_color white--text" style="border-radius: 15px;" large @click="getProcessesByCategory">
              <v-icon class="main_color white--text">
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-col>

        </v-row>
        <v-card
            v-for="procedure in procedures"
            :key="procedure.id"
            :class="[getStatusColor(procedure.status.name) + '_card_mobile','mb-2',]">
          <v-card-title style="word-break:normal">
            {{ procedure.process.name }}
          </v-card-title>
          <v-card-subtitle :class="getStatusColor(procedure.status.name) + '--text'" style="text-align:left">
            {{ procedure.status.male_label }}
          </v-card-subtitle>

          <v-card-text>
            <v-row style="opacity: 0.8;">
              <v-col cols="5" class="fecha-col-mobil mr-2">
                <v-row>
                  <p class="fecha-mobil" style="margin: 0">
                    {{ procedure.stages.length > 0 ? procedure.stages[0].created_at : '' }}
                  </p>
                </v-row>
              </v-col>
              <v-col cols="5" class="fecha-col-mobil ml-2">
                <v-row>
                  <p class="fecha-mobil" style="margin: 0">
                    {{ procedure.stages.length > 0 ? procedure.stages[0].task.name : '' }}
                  </p>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn depressed class="primary_border main_color white--text" small
                   @click="showProcedureStages(procedure.stages)">
               <img class="ico_item_action"  :src="$renderImageFromAssets('icon_show_progress')"/>
              Ver Proceso
            </v-btn>
            <router-link
                v-if="procedure.status.name === 'active'"
                class="text-decoration-none"
                :to="{name: 'procedure_continue', params: { stageId: procedure.stages[0].id }}">
              <v-btn depressed class="success_border botoncolorsegundo white--text" small>
                <!-- <img class="ico_item_action"  :src="$renderImageFromAssets('icon_continue')"/> -->
                Continuar trámite
              </v-btn>
            </router-link>

            <v-menu
                v-if="procedure.status.name === 'finished'"
                offset-y
                origin="center center"
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="primary_border main_color white--text"
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    small>
                  <!-- <v-icon color="primary" small left>fas fa-eye</v-icon> -->
                  Ver historial
                  <v-icon x-small right>fas fa-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <template v-for="stage in procedure.stages">
                  <v-list-item
                      v-if="stage.status.name === 'finished' && stage.user_assigned != null &&
                                                      stage.user_assigned.id == accountStore.user.id" :key="stage.id">
                    <v-list-item-title>
                      <router-link
                          :to="{name: 'procedure_view', params: { stageId: stage.id }}"
                          class="text-decoration-none main_color--text">
                        {{ stage.task.name }}
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </v-card-actions>

        </v-card>
      </div>

      <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
      <v-row class="" v-if="!isMobile">
        <v-col :cols="isMobile ? '9' : '11'" class="pt-0 pb-0">
          <v-text-field
              type="text"
              solo
              style="border-radius: 15px;"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar trámite por nombre..."
              v-model="search"
              @keyup.enter="getProceduresList"
          />
        </v-col>
        <v-col :cols="isMobile ? '3' : '1'" class="pt-0 pb-0" >
          <v-btn class="main_color white--text" style="border-radius: 15px;" large @click="getProcessesByCategory">
            <v-icon class="main_color white--text">
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title class="title_table--text font-weight-bold" v-if="isMobile">
              <template v-if="proceduresStore.filterStatus === 1">
                Trámites pendientes
              </template>
              <template v-else-if="proceduresStore.filterStatus === 2">
                Trámites completados y/o finalizados
              </template>
              <template v-else-if="proceduresStore.filterStatus === 3">
                Trámites cancelados
              </template>
              <template v-else-if="proceduresStore.filterStatus === 5">
                Trámites en proceso de revisión y/o validación
              </template>
              <template v-else-if="proceduresStore.filterStatus === 7">
                Nuevo Trámite
              </template>
              <template v-else>
                Todos los trámites del ciudadano ({{ proceduresStore.totalCounter }})
              </template>
            </v-card-title>
            <v-simple-table>
              <thead class="bg_table_th">
              <tr class="custom-table-header">
                <th>
                  <div class="th-content">
                    <div class="th-icon">
                      <i class="fas fa-list"></i>
                    </div>
                    <span class="text_title_table">ID</span>
                  </div>
                </th>

                <th>
                  <div class="th-content">
                    <div class="th-icon">
                      <i class="fas fa-file-alt"></i>
                    </div>
                    <span class="text_title_table">Nombre</span>
                  </div>
                </th>

                <th>
                  <div class="th-content">
                    <div class="th-icon" >
                      <i class="fas fa-ellipsis-h"></i>
                    </div>
                    <span class="text_title_table">Etapa</span>
                  </div>
                </th>

                <th>
                  <div class="th-content">
                    <div class="th-icon">
                      <i class="fas fa-calendar-alt"></i>
                    </div>
                    <span class="text_title_table">Fecha</span>
                  </div>
                </th>

                <th>
                  <div class="th-content">
                    <div class="th-icon">
                      <i class="fas fa-exclamation"></i>
                    </div>
                    <span class="text_title_table">Estatus</span>
                  </div>
                </th>

                <th>
                  <div class="th-content">
                    <div class="th-icon">
                      <i class="fas fa-window-maximize"></i>
                    </div>
                    <span class="text_title_table">Acciones</span>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="procedure in procedures" :key="procedure.id">
                <td>#{{ procedure.id }}</td>
                <td>{{ procedure.process.name }}</td>
                <td class="task-with-dot">
                  {{ procedure.stages.length > 0 ? procedure.stages[0].task.name : '' }}
                </td>
                <td class="date-cell">
                  <v-icon small>mdi-calendar</v-icon>
                  <span>
                    {{procedure.stages.length > 0 ? procedure.stages[0].created_at.replaceAll('-', '/') : '' }}
                  </span>
                </td>
                <td>
                  <div :class="['status-badge', getStatusClass(procedure.status.name)]">
                    <span class="status-dot"></span>
                    {{ procedure.status.male_label }}
                  </div>
                </td>
                <td>
                  <v-btn
                      class="action-btn main_color"
                      @click="showProcedureStages(procedure.stages)"
                      icon
                  >
                    <v-icon color="white">mdi-eye</v-icon>
                  </v-btn>
                  <!-- PENDIENTE -->
                  <router-link
                      v-if="procedure.status.name === 'active'"
                      class="text-decoration-none"
                      :to="{name: 'procedure_continue', params: { stageId: procedure.stages[0].id }}">
                    <v-btn
                        class="action-btn main_color"
                        icon
                    >
                      <v-icon color="white">mdi-arrow-right</v-icon>
                    </v-btn>
                  </router-link>

                  <!-- TERMINADO -->
                  <v-menu
                      v-if="procedure.status.name === 'finished'"
                      offset-y
                      origin="center center"
                      transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="action-btn main_color"
                          v-bind="attrs"
                          v-on="on"
                          icon
                      >
                        <v-icon color="white">mdi-clock-outline</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <template v-for="stage in procedure.stages">
                        <v-list-item
                            v-if="stage.status.name === 'finished' && stage.user_assigned != null &&
                                                        stage.user_assigned.id == accountStore.user.id" :key="stage.id">
                          <v-list-item-title>
                            <router-link
                                :to="{name: 'procedure_view', params: { stageId: stage.id }}"
                                class="text-decoration-none main_color--text">
                              {{ stage.task.name }}
                            </router-link>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <div class="d-flex justify-end pa-2 pb-4">
        <v-pagination
            color="main_color"
            v-if="hasPagination"
            v-model="page"
            :length="paginator.total_pages"
            total-visible="10"
            @input="getProceduresList"
        ></v-pagination>
      </div>

      <!-- END TABLE FOR PROCESSES   -->
      <procedure-stages show-modal=""></procedure-stages>
    </div>

  </v-container>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import ProcedureStages from '@/components/dashboard/ProcedureStages';
import {
  getProcedureStatusColor,
  getProcedureStatusIcon,
} from '@/core/assets_utils';
import router from '@/config/router';
import {procedureListRequest} from '@/api/models';

export default {
  name: 'Dashboard',
  components: {ProcedureStages},
  computed: {
    ...mapState({
      accountStore: (state) => state.account,
      proceduresStore: (state) => state.procedures,
    }),
    ...mapGetters('procedures', ['hasPagination', 'paginator', 'procedures']),

    pageTitle() {
      switch (this.proceduresStore.filterStatus) {
        case 1:
          return 'Trámites pendientes';
        case 2:
          return 'Trámites completados';
        case 3:
          return 'Trámites cancelados';
        case 5:
          return 'Trámites en proceso';
        case 7:
          return 'Nuevo Trámite';
        default:
          return 'Todos mis trámites';
      }
    }
  },



  data() {
    return {
      TOTAL_COUNT: 0,
      FILTER_STATUS_ACTIVE: 1,
      FILTER_STATUS_FINISHED: 2,
      FILTER_STATUS_CANCELED: 3,
      FILTER_STATUS_DELETED: 4,
      FILTER_STATUS_IN_PROCESS: 5,

      cards: [
        {
          id: 1,
          status: 'active',
          title: 'Pendientes',
          color: 'bg_home_card_1',
          css: 'card_1',
        },
        {
          id: 5,
          status: 'in-process',
          title: 'En Proceso',
          color: 'bg_home_card_2',
          css: 'card_2',
        },
        {
          id: 3,
          status: 'canceled',
          title: 'Cancelados',
          color: 'bg_home_card_3',
          css: 'card_3',
        },
        {
          id: 2,
          status: 'finished',
          title: 'Completados',
          color: 'bg_home_card_4',
          css: 'card_4',
        },
      ],
      page: 1,
      pageLimit: 10,
      procedureStages: [],
      showProcedureStagesModal: false,
      fab: false,
      isMobile: false,
      search: '',
    };
  },

  created() {
    this.$gtag.event('home', {method: 'Google'});
  },

  mounted() {
    this.waitForUser(() => {
      this.clearProcedures();
      this.getProceduresList();
      this.countProcedures();
    });
  },


  methods: {
    ...mapActions('procedures', [
      'getProceduresByUser',
      'clearProcedures',
      'getProceduresCount',
    ]),
    ...mapMutations('procedures', ['showList']),
    ...mapMutations('appBar', ['changeViewOpened']),
    waitForUser(callback) {
      const interval = setInterval(() => {
        if (this.accountStore.user && this.accountStore.user.id) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    },

    returnIcon(status) {
      let icon = '';
      switch (status) {
        case 'active':
          icon = 'mdi-clock-time-eight-outline';
          break;

        case 'finished':
          icon = 'mdi-check';
          break;

        case 'in-process':
          icon = 'mdi-lightning-bolt';
          break;

        case 'canceled':
          icon = 'mdi-close-thick';
          break;

        case 'deleted':
          icon = 'mdi-trash-can';
          break;

        default:
          icon = 'mdi-alert';
          break;
      }
      return icon;
    },

    filterProcedures() {
      /* let filter = this.procedures.filter((procedure) =>
          procedure.process.name.toLowerCase().includes(this.search.toLowerCase())
      ); */
      // this.showList(filter);
    },

    getProceduresList() {
      let request = procedureListRequest();
      request.userId = this.accountStore.user ? this.accountStore.user.id : 0;
      request.status = this.proceduresStore.filterStatus;
      request.limit = this.proceduresStore.pageLimit;
      request.page = this.page;
      request.query = this.search;

      this.getProceduresByUser(request);
    },

    getStatusClass(status) {
      switch (status) {
        case 'finished':
          return 'status-success'

        case 'active':
        case 'in-process':
          return 'status-warning'

        case 'canceled':
          return 'status-danger'

        default:
          return 'status-default'
      }
    },

    countProcedures() {
      this.getProceduresCount();
    },

    showProcedureStages(stages) {
      this.showProcedureStagesModal = true;
      this.procedureStages = stages;
    },

    getCountNumber(status) {
      if (this.proceduresStore.proceduresCounter) {
        if (status === 'active') {
          return this.proceduresStore.proceduresCounter.pending;
        } else if (status === 'in-process') {
          return this.proceduresStore.proceduresCounter.in_process;
        } else if (status === 'canceled') {
          return this.proceduresStore.proceduresCounter.canceled;
        } else if (status === 'finished') {
          return this.proceduresStore.proceduresCounter.complete;
        }
      }

      return 0;
    },

    getStatusColor(status) {
      return getProcedureStatusColor(status);
    },

    getStatusIcon(status) {
      return getProcedureStatusIcon(status);
    },

    filterProceduresList(filterStatus) {
      this.currentFilter = filterStatus;

      if (filterStatus < 6 && router.currentRoute.name !== 'home') {
        router.push({name: 'home'});
      }

      if (filterStatus !== this.proceduresStore.filterStatus) {
        let request = procedureListRequest();
        request.userId = this.accountStore.user.id;
        request.status = filterStatus;
        request.limit = this.proceduresStore.pageLimit;

        this.getProceduresByUser(request);
      }
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};


</script>

<style scoped>

.theme--light.v-pagination .v-pagination__navigation {
  background: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
}

.custom-table-header {
  background-color: #6d0f2c; /* tono guinda */
}

.custom-table-header th {
  padding: 20px;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}
.date-cell {

  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.th-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.th-icon {
  color: #ececec;
  margin-top: 0.7rem;
  margin-bottom: 0.7rem;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.text_title_table{
  color: #e8e8e8;
  font: bold 14px/18px 'Roboto', sans-serif;
}


.status-badge {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  gap: 10px;
  padding: 10px 22px;
  border-radius: 17px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid;
  transition: all 0.2s ease;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-success {
  color: #2f5d50;
  border-color: #2f5d50;
  background-color: rgba(47, 93, 80, 0.08);
}

.status-success .status-dot {
  background-color: #2f5d50;
}

.status-warning {
  color: #c58a00;
  border-color: #c58a00;
  background-color: rgba(197, 138, 0, 0.08);
}

.status-warning .status-dot {
  background-color: #c58a00;
}

.status-danger {
  color: #b42318;
  border-color: #b42318;
  background-color: rgba(180, 35, 24, 0.08);
}

.status-danger .status-dot {
  background-color: #b42318;
}

.status-default {
  color: #555;
  border-color: #555;
}

.status-default .status-dot {
  background-color: #555;
}


.task-with-dot {

  align-items: center;
  gap: 10px;
}

.task-with-dot::before {
  content: "";
  width: 8px;
  height: 8px;
  background-color: #6d0f2c; /* mismo guinda que usas */
  border-radius: 50%;
  display: inline-block;
}

.action-btn {
  width: 3rem;
  margin-right: 0.5rem;
  height: 3rem;
  border-radius: 18px !important;
  background-color: #6d0f2c !important;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  transition: all 0.2s ease;

}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
}

</style>
